<template>
  <div class="select-element" :name="name" :style="{'--font-size': font_size}">
    <InputElement :tooltip="tooltip" :readonly="readonly" :external_error="external_error" :font_size="font_size" @icon="handleIconEvent" :block_blur="true" ref="input" :label="label" :required="required" :icon_name="icon_name" :cursor="false" @blur="handleInputBlur()" @focus="handleInputFocus($event)"/>
    <dialog class="dialog-select-options" ref="dialog" @click.stop.prevent>
      <div class="select-options">
        <input type="text" placeholder="filter..." v-model="search_string" v-if="data.length>20">
        <div class="select-option" @click="select(option)" v-for="option in filter(data,search_string)" :key="option" :class="{active:option.id===value?.id}">
          <div class="option-name" >
            {{option.name}}
          </div>
        </div>
      </div>
    </dialog>
    <input type="hidden" :value="value ? JSON.stringify(value) : null" :name="name">
  </div>
</template>

<script>
import InputElement from '@/components/inputs_23/InputElement.vue'
export default {
  name: 'SelectElement',
  components: {
    InputElement,
  },
  props: {
    label: String,
    name: [String,Number],
    placeholder: String,
    bg: {
      type: String,
      default: "#fff",
    },
    color: {
      type: String,
      default: "#00876c",
    },
    required: Boolean,
    disabled: Boolean,
    external_error: Object,
    data: Array,
    font_size: {
      type: String,
      default: '1rem',
    },
    tooltip: String,
    readonly: Boolean,
    default_value: Number,
  },
  data() {
    return {
      active: false,
      search_string: '',
      value: null,
    }
  },
  mounted() {
    if(this.default_value) {
      this.select(this.data.find(option=>option.id==this.default_value))
    }
  },
  computed: {
    icon_name() {
      if(this.value) {
        return "close"
      }
      if(this.active) {
        return "caret-up-outline"
      }
      return "caret-down-outline"
    },
    error() {
      if(this.$refs.input.error) {
        return this.$refs.input.error
      }
      return null
    }
  },
  methods: {
    clear() {
      this.$refs.input.clear()
      if(this.default_value) {
        this.select(this.data.find(option=>option.id==this.default_value))
      } else {
        this.value = null
      }
    },
    setValue(value) {
      this.select(this.data.find(option=>option.id==value))
    },
    showError() {
      this.$refs.input.showError()
    },
    handleIconEvent() {
      if(this.value) {
        this.value = null
        this.$refs.input.value = null
        return
      }
      if(this.active) {
        this.close()
      }
      this.$refs.input.focus()
      // this.handleInputFocus()
    },
    select(option) {
      if(option?.id===this.value?.id) {
        return
      }
      this.value = option
      this.$refs.input.value = option.name
      this.close()
      this.$emit('change',this.value.id)
    },
    escapeCharacters(string) {
      string=string.replace('[', '\\[')
      string=string.replace(']', '\\]')
      string=string.replace('.', '\\.')
      return string
    },
    filter(data,search_string) {
      return data.filter(entry=>{
        var veto_row = true
        if(search_string=='' || !search_string || (entry.name && `${entry.name}`.match(new RegExp(this.escapeCharacters(search_string), "i")))) {
          veto_row = false
        }
        return !veto_row
      })
    },
    handleInputBlur() {
      this.$refs.dialog.close()
    },
    close() {
      this.$refs.dialog.close()
      this.$refs.input.blur()
      this.active = false
      window.removeEventListener("click",this.windowClickHandler)
    },
    windowClickHandler(e) {
      const dialogDimensions = this.$refs.dialog.getBoundingClientRect()
      if(dialogDimensions.left===0 && dialogDimensions.right===0) {
        this.$refs.dialog.show()
        this.active = true
        return
      }
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        this.close()
      }
    },
    handleInputFocus() {
      window.addEventListener('click', this.windowClickHandler)
    },
  },
}
</script>


<style scoped lang="scss">
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.select-element {
  position: relative;
  font-family: 'Quicksand', sans-serif;
  font-weight: 500;
  // font-size: 1.125rem;
  font-size: var(--font-size);
  // font-size: 1rem;
  .dialog-select-options {
    width: 100%;
    z-index: 99;
    border-radius: 6px;
    border: 1px solid $kit_green;
    outline: 1px solid $kit_green;
    padding: 0.5rem 0;
    max-height: 236px;
    overflow-y: auto;
    .select-options {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      input {
        margin: 0.25rem 0.75rem;
        padding: 0.25rem 0.75rem;
        font-family: 'Quicksand', sans-serif;
        font-weight: 500;
        // font-size: 1.125rem;
        font-size: var(--font-size);
        // font-size: 1rem;
      }
      .select-option {
        margin: 0 0.75rem;
        padding: 0.25rem 0.75rem;
        border: 1px solid $text_dark;
        cursor: pointer;
        &:hover {
          background-color: $text_dark;
          color: $text_light;
        }
        
      }
    }
  }
}
</style>
